/**
 * Created by Jerker Nord on 2018-06-27.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";
import {IceIceYetiInitialWPView} from "./IceIceYetiInitialWPView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IceIceYetiInitialToggleWPView} from "./IceIceYetiInitialToggleWPView";

export class IceIceYetiInitialWPController extends WinPresentationController {

    public _initialToggleView:IceIceYetiInitialToggleWPView;
    public _displayIndividualWinsInGame:boolean;

    private _initialView:IceIceYetiInitialWPView;
    private _playInitialWin:boolean;
    private _playInitialToggleWin:boolean;
    private _allWinPositions:boolean[][];
    private _totalWin:number;
    private _isAborted:boolean;
    private _isBigWin:boolean;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "IceIceYetiInitialWPController", skippable : true});

        this._initialView = new IceIceYetiInitialWPView();
        this._initialToggleView = new IceIceYetiInitialToggleWPView();

        this._playInitialWin = false;
        this._isBigWin = false;
    }

    protected parseFeatureGameData(data:IceIceYetiParsedGameData):void {
        if(this.hasWin()) {
            if((data.mode == GameMode.RESPIN && data.nextMode == GameMode.NORMAL) || data.mode == GameMode.NORMAL && data.nextMode != GameMode.RESPIN) {
                this._allWinPositions = data.allWinPositions;
                this._totalWin = data.totalWin;
                this._playInitialWin = true;
                this._displayIndividualWinsInGame = SlotGame.api.gameClientConfiguration.displayIndividualWinsInGame;
                this._isAborted = false;
                this._isBigWin = data.isBigWin;
            }
        }
    }

    protected hasWin():boolean {
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected startWinPresentation():void {
        if(this._playInitialWin == true && this._allWinPositions.length > 0) {
            if (this._displayIndividualWinsInGame == true && this._isBigWin == false){
                this._playInitialToggleWin = true;
                this._initialToggleView.playWinPresentation(() => this.playInitialWin());
            }else{
                this.playInitialWin();
            }
        } else {
            this.finish();
        }
    }

    private playInitialWin():void{
        this._playInitialToggleWin = false;
        for(let i:number = 0; i < this._allWinPositions.length; i++) {
            this._initialView.addReelWinPresentation(i, this._allWinPositions[i]);
        }
        this._initialView.playWinPresentation(() => this.presentationComplete(), this._totalWin);
    }

    private presentationComplete():void{
        if (this._isAborted == false){
            this.finish();
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        this._isBigWin = false;
        this._isAborted = isAborted;
        if(this._playInitialWin == true) {
            if (this._playInitialToggleWin == true){
                this._initialToggleView.stopWinPresentation();
            }
            this._playInitialWin = false;
            this._initialView.stopWinPresentation(isAborted);
        }
    }
}